/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Visit_CtaInputs */

const en_price_page_visit_cta = /** @type {(inputs: Price_Page_Visit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See price lists`)
};

const pl_price_page_visit_cta = /** @type {(inputs: Price_Page_Visit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz cenniki`)
};

/**
* | output |
* | --- |
* | "See price lists" |
*
* @param {Price_Page_Visit_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_visit_cta = /** @type {((inputs?: Price_Page_Visit_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Visit_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_visit_cta(inputs)
	return en_price_page_visit_cta(inputs)
});